<template>
  <div>
    <b-modal
      id="tools"
      modal-class="tools"
      hide-header
      hide-footer
      centered
      @hide="updateTools"
    >
      <!-- visible -->
      <template v-if="showtools == 'tools'">
        <div class="header__tools">
          <span class="ico" @click="$bvModal.hide('tools')">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
              <path
                d="M28 18H8M8 18L16 10M8 18L16 26"
                stroke="#606770"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <h3>Tools</h3>
          <span
            class="ico ico__search"
            @click="showtools = 'search'"
            v-b-tooltip.hover
            title="Search Tool"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
                fill="black"
                fill-opacity="0.5"
              />
              <path
                d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
                fill="black"
                fill-opacity="0.5"
              />
            </svg>
          </span>
        </div>
        <div class="body__tools">
          <div class="filter">
            <p>Filter by Categories</p>
            <div class="filters">
              <div
                class="filter_"
                v-for="(tag, i) in tags"
                :key="i"
                @click="toogleFilter(tag)"
                :class="{ active: activeTags.indexOf(tag) >= 0 }"
              >
                {{ tag }}
              </div>
            </div>
          </div>
          <div class="tool__wraper">
            <div
              class="tool"
              v-for="(tool, n) in filteredTools"
              :key="n"
              :class="{ active: activeTools.includes(tool.name.toLowerCase()) }"
            >
              <div class="tool-event" @click="toogleTool(tool)">
                <div>
                  <div class="left">
                    <img
                      class="tool-image"
                      :src="tool.imgURL"
                      :alt="tool.name"
                    />
                    <h4>{{ tool.name }}</h4>
                  </div>

                  <div class="ico check">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                      <path
                        d="M4 13.875L8.09091 18L19 7"
                        stroke="var(--theme-color)"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                </div>
                <p v-if="tool.description && tool.description.length > 100">
                  {{ tool.description.substring(0, 100) }}...
                </p>
                <p v-else>{{ tool.description }}</p>
              </div>
              <div
                class="ico video"
                v-b-tooltip.hover
                title="Add tool"
                @click="addToolInstant(tool)"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="showtools == 'display'">
        <div class="header__tools border-none">
          <span class="ico" @click="showtools = 'tools'">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
              <path
                d="M28 18H8M8 18L16 10M8 18L16 26"
                stroke="#606770"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <!-- <h3>Tools</h3> -->
        </div>
        <div class="body__tools">
          <div class="description__wraper">
            <img
              :src="activeDisplayTool.imgURL"
              :alt="activeDisplayTool.name"
            />
            <span class="icon" @click="playToolVideo">
              Watch Video
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.048 5.09236C20.3255 5.2352 20.5 5.52118 20.5 5.83334V14.1667C20.5 14.4788 20.3255 14.7648 20.048 14.9076C19.7704 15.0505 19.4363 15.0262 19.1823 14.8448L13.349 10.6781C13.13 10.5217 13 10.2691 13 10C13 9.73088 13.13 9.47832 13.349 9.32189L19.1823 5.15523C19.4363 4.97379 19.7704 4.94953 20.048 5.09236ZM15.2671 10L18.8333 12.5473V7.45266L15.2671 10Z"
                    fill="var(--theme-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 4.99967C2.53976 4.99967 2.16667 5.37277 2.16667 5.83301V14.1663C2.16667 14.6266 2.53976 14.9997 3 14.9997H12.1667C12.6269 14.9997 13 14.6266 13 14.1663V5.83301C13 5.37277 12.6269 4.99967 12.1667 4.99967H3ZM0.5 5.83301C0.5 4.4523 1.61929 3.33301 3 3.33301H12.1667C13.5474 3.33301 14.6667 4.4523 14.6667 5.83301V14.1663C14.6667 15.5471 13.5474 16.6663 12.1667 16.6663H3C1.61929 16.6663 0.5 15.5471 0.5 14.1663V5.83301Z"
                    fill="var(--theme-color)"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <h3>{{ activeDisplayTool.name }}</h3>
            <div>
              <p>
                {{ activeDisplayTool.description }}
              </p>
            </div>
            <div class="tool-images" v-if="activeDisplayTool.images.length > 0">
              <img
                v-for="(image, index) in activeDisplayTool.images"
                :key="index"
                :src="image"
                class="tool-image"
                alt="Tool Image"
              />
            </div>
            <div v-else class="empty-block"></div>
            <!-- <div v-html="activeDisplayTool.desc"></div> -->
            <button class="btn-add-crew" @click="handleAddThis">
              + ADD THIS
            </button>
          </div>
        </div>
      </template>
      <template v-if="showtools == 'search'">
        <div class="header__tools header__search">
          <input
            type="search"
            class="search"
            v-model="searchStr"
            placeholder="Search"
          />
          <span class="ico" @click="hideSearch">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="14.2222"
                    height="14.2222"
                    fill="white"
                    transform="translate(8.88867 8.88892)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
        <div class="body__tools">
          <div class="tool__wraper">
            <div
              class="tool"
              v-for="(tool, n) in searchedTools"
              :key="n"
              @click="toogleTool(tool)"
              :class="{ active: activeTools.includes(tool.name.toLowerCase()) }"
            >
              <div>
                <div class="left">
                  <img :src="tool.imgURL" alt="tool-image" width="50" />
                  <h4>{{ tool.name }}</h4>
                </div>
                <div class="ico video">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="12"
                      fill="var(--theme-color)"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M12.0002 5.14282V18.8571"
                      stroke="var(--theme-color)"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M5.14282 12.0002L18.8571 12.0002"
                      stroke="var(--theme-color)"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div class="ico check">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                    <path
                      d="M4 13.875L8.09091 18L19 7"
                      stroke="var(--theme-color)"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <vimeo-modal
      v-if="activeDisplayTool.video && activeDisplayTool.video.videoId"
      :id="toolVideo"
      :videoId="activeDisplayTool.video.videoId"
      :videoThumb="
        activeDisplayTool.video.videoThumb
          ? activeDisplayTool.video.videoThumb
          : null
      "
    ></vimeo-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vimeoModal from "@/components/common/vimeoModal";

export default {
  data() {
    return {
      tools: [],
      toolVideo: "focus-tool-video",
      tags: ["Spiritual", "Health", "Education", "Finance"],
      activeTags: [],
      showtools: "tools", //tools, display, search
      activeTools: [],
      searchStr: "",
      activeDisplayTool: {}
    };
  },
  mounted() {
    this.$store.dispatch("tools/getListTools");
    this.$store.dispatch("user/getListTools");
  },
  components: {
    vimeoModal
  },
  watch: {
    showtools(newv, oldv) {
      if (newv == "search") {
        setTimeout(() => {
          document.querySelector(".search").focus();
        }, 100);
      }
    }
  },
  computed: {
    ...mapGetters({
      allTools: "tools/listTools"
    }),
    searchedTools() {
      if (this.searchStr.trim() == "") return this.allTools;

      return this.allTools.filter(tool => {
        return tool.name
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    },
    filteredTools() {
      return this.allTools.filter(tool => {
        let check = true;
        this.activeTags.forEach(tag => {
          if (!tool.tags.includes(tag.toLowerCase())) check = false;
        });
        return check;
      });
    }
  },
  methods: {
    addToolInstant(tool) {
      this.activeTools.push(tool.name.toLowerCase());
      this.addTool(tool);
    },
    hideSearch() {
      this.searchStr = "";
      this.showtools = "tools";
    },
    toogleFilter(tag) {
      let index = this.activeTags.indexOf(tag);
      if (index >= 0) {
        this.activeTags.splice(index, 1);
      } else {
        this.activeTags.push(tag);
      }
    },
    toogleTool(tool) {
      console.log("here", tool);
      this.searchStr = "";
      let toolIndex = this.activeTools.indexOf(tool.name.toLowerCase());
      if (toolIndex >= 0) {
        this.activeTools.splice(toolIndex, 1);
        this.tools.splice(toolIndex, 1);
      } else {
        this.activeDisplayTool = tool;
        this.showtools = "display";
      }
    },
    handleAddThis() {
      this.activeTools.push(this.activeDisplayTool.name.toLowerCase());
      this.showtools = "tools";
      this.addTool(this.activeDisplayTool);
    },
    playToolVideo() {
      if (
        this.activeDisplayTool.video &&
        this.activeDisplayTool.video.videoId &&
        this.activeDisplayTool.video.videoThumb
      )
        this.$bvModal.show(this.toolVideo);
    },
    addTool(tool) {
      let uid = this.checkIsToolOnDb(tool.name);
      let toolName = tool.name.split(",");
      let { _created_at, description, imgURL, name, toolId, toolRef } = tool;
      let tooldetail = {};
      if (_created_at) tooldetail._created_at = _created_at;
      if (description) tooldetail.description = description;
      if (imgURL) tooldetail.imgURL = imgURL;
      if (name) tooldetail.name = name;
      if (toolId) tooldetail.toolId = toolId;
      if (toolRef) tooldetail.toolRef = toolRef.path;
      let toolObject = {
        _created_at: new Date(),
        text: toolName[0],
        subText: toolName.length > 1 ? toolName[1] : "",
        uid: uid > -1 ? uid : undefined,
        tooldetail: tooldetail
      };
      this.tools.push(toolObject);
    },
    updateTools() {
      this.$emit("updateTools", this.tools);
    },
    checkIsToolOnDb(name) {
      let existingTools = this.$store.getters["user/listTools"].map(
        el => el.text
      );
      if (existingTools.includes(name)) {
        return this.$store.getters["user/listTools"][
          existingTools.indexOf(name)
        ].uid;
      } else {
        return false;
      }
    },
    checkIsToolExistedOn_focus(toolId) {
      let existingTools = this.$store.getters["user/listTools"];
      let listToolUidOnFocus = this.focus.tools.map(el => el.tools_id);
      let listToolToolIds = this.focus.tools.map(
        el => el.tooldetail && el.tooldetail.toolId
      );
      let focusTools = existingTools.filter(el =>
        listToolUidOnFocus.includes(el.uid)
      );
      let focusToolsListUids = focusTools.map(el => el.tooldetail.toolId);
      if (
        focusToolsListUids.includes(toolId) ||
        listToolToolIds.includes(toolId)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tools {
  .header__tools {
    position: relative;
    padding-bottom: 8px;
    &.border-none::after {
      content: none !important;
    }
    .ico {
      position: absolute;
      top: 5px;
      left: 13px;
      cursor: pointer;
    }
    .ico__search {
      left: unset !important;
      right: 13px;
    }
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;

      color: #5b606c;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      border-bottom: 1px solid #e4e6eb;
    }
  }
  .body__tools {
    height: 100%;
    .filter {
      display: flex;
      align-items: center;
      margin-top: 20px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #5b606c;
        width: 160px;
        margin: 0;
      }
      .filters {
        height: 45px;
        display: flex;
        align-items: center;
        max-width: 100%;
        overflow-x: scroll;
        &::-webkit-scrollbar {
          height: 0px;
          margin-right: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: #dddddd;
          // border-radius: 16px;
        }
        .filter_ {
          cursor: pointer;
          padding: 8px 16px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          background-color: #fff;
          color: #5b606c;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
          border-radius: 32px;
          margin-right: 16px;
          &.active {
            background: rgba(85, 126, 251, 0.1);
            color: var(--theme-color);
            box-shadow: none;
          }
        }
      }
    }
    .tool__wraper {
      padding: 32px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px 12px;
      max-height: 530px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
    }
    .tool {
      cursor: pointer;
      position: relative;
      border-radius: 5px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      .tool-event {
        padding: 18px;
        & > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .video {
        position: absolute;
        top: 22px;
        right: 18px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
        margin-top: 10px;
        margin-bottom: 0;
      }
      h4 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin-bottom: 0;
        margin-left: 10px;
      }
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .check {
        display: none;
      }
      &.active {
        .check {
          display: block !important;
        }
        .video {
          display: none !important;
        }
        background-color: #e8eaf9;
      }
    }
    .description__wraper {
      width: 100%;
      height: 100%;
      display: flex;
      // justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      img {
        margin-top: 34px;
        height: 70px;
        width: 70px;
        border-radius: 50%;
      }
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #5b606c;
        margin-bottom: 15px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;

        color: #5b606c;
      }
      .tool-images {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        img {
          margin: 0 3px;
          margin-top: 50px;
          width: 105px;
          height: 130px;
          border-radius: 5px;
        }
      }
      .empty-block {
        height: 270px;
      }
      .btn-add-crew {
        margin-bottom: 30px;
        position: absolute;
        bottom: 0px;
        width: 90%;
      }
    }
  }
}
.header__search {
  display: flex;
  align-items: center;
  input {
    border: none;
    padding: 5px 10px;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    //   text-align: center;
    color: #5b606c;
  }
  .ico {
    left: unset !important;
    right: 13px;
  }
}
.tool-image {
  width: 50px;
}
@media (max-width: 520px) {
  .body__tools {
    grid-template-columns: 1fr !important;
  }
}
.icon {
  margin: 15px 0;
  color: var(--theme-color);
  padding: 3px;
  cursor: pointer;
  border: 1px solid var(--theme-color);
  border-radius: 25px;
}
</style>
